export const NATIVE_APP_SCHEME = "revisionfoundry";

export function makeNativeAppUrl(path) {
  const cleanPath = String(path || "/").replace(/^\/+/, "");
  return `${NATIVE_APP_SCHEME}://${cleanPath}`;
}

export function routeFromNativeAppUrl(rawUrl) {
  try {
    const url = new URL(rawUrl);
    if (url.protocol !== `${NATIVE_APP_SCHEME}:`) return null;

    // For revisionfoundry://sso-callback, the callback route is the URL host.
    const routeParts = [url.hostname, url.pathname.replace(/^\/+/, "")]
      .filter(Boolean);
    const pathname = routeParts.length ? `/${routeParts.join("/")}` : "/";
    return `${pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function navigateToNativeAppUrl(rawUrl) {
  const route = routeFromNativeAppUrl(rawUrl);
  if (!route) return false;

  window.history.replaceState(window.history.state, "", route);
  window.dispatchEvent(new PopStateEvent("popstate"));
  return true;
}